import CompanyChecker from './company_checker';
import { Box, Container, Stack } from '@mui/material';
import Steps from './steps';
import Benefits from './benefits';
import RegistrationRequirements from './registration_requirements';
import ContactUs from '../contactUs';
import FAQ from './faq';
import BankAccounts from './bank_accounts';
import WhyWe from './whywe';
import PackagesSection from '../packages';

const Home = () => {
  return (
    <>
      <Stack direction={'column'} spacing={8}>
        <Box>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/offce_space_1.jpg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              zIndex: -1,
            }}
          />
          <Container>
            <CompanyChecker />
            <Steps />
          </Container>
        </Box>
      </Stack>
      <Container sx={{ pt: 2 }}>
        <Stack spacing={8}>
          <Benefits />
          <BankAccounts />
          <RegistrationRequirements />
          <WhyWe />
          <PackagesSection />
          <ContactUs />
          <FAQ />
        </Stack>
      </Container>
    </>
  );
};

export default Home;
